/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Heading, Icon, Button, ExternalLink, useWindowSize } from 'sarsaparilla';
import { FACEBOOK, INSTAGRAM } from 'site-kit';

export default function QuickLinks() {
    const promoItems = [
        {
            url: '/mobile-app',
            icon: <Icon iconName="apple" />,
            title: `Download our iOS App`,
        },
        {
            url: '/mobile-app',
            icon: <Icon iconName="android" />,
            title: `Get our Android App`,
        },
        {
            url: 'https://www.sharetheexperience.org/',
            icon: <Icon iconName="photo" />,
            title: `Share the Experience photo contest`,
            isExternal: true,
        },
        {
            url: INSTAGRAM,
            icon: <Icon iconName="instagram" />,
            title: `Follow us on Instagram`,
            isExternal: true,
        },
        {
            url: FACEBOOK,
            icon: <Icon iconName="facebook" />,
            title: `Like Us on Facebook`,
            isExternal: true,
        },
    ];

    // Find the width of the page
    const { width } = useWindowSize();

    // Change the size of the heading depending on the width of the page
    const setHeadingSize = width <= 992 ? 'h4' : 'h5';

    return (
        <div className="nav-quick-links-wrap">
            <Heading headingLevel={3} appearance={setHeadingSize} hasUnderline="left">
                Quick Links
            </Heading>

            <ul>
                {promoItems.map((promoItem, index) => {
                    return (
                        <li key={index}>
                            {promoItem.isExternal ? (
                                <ExternalLink
                                    hasExternalIcon={false}
                                    url={promoItem.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    gaTrackingId="666162115404"
                                >
                                    {promoItem.icon}
                                    {promoItem.title}
                                </ExternalLink>
                            ) : (
                                <Button
                                    isUnstyled
                                    href={promoItem.url}
                                    gaTrackingId="666162115404"
                                >
                                    {promoItem.icon}
                                    {promoItem.title}
                                </Button>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
